import { localStorageService } from "./localStorage.service"

/**
 * Extracts the identifier from an IRI path.
 * This is used to obtain the UUID from an object IRI.
 *
 * @param {String} iri The iri path
 * @returns The UUID or identifier extracted from the IRI
 */
export function iriToUuid(iri) {
  return iri.split("/").pop()
}
/**
 * Transforms an uuid to an IRI.
 *
 * @param {String} url Resource url
 * @param {String} identifer Resource's IRI or UUID
 * @returns The resource IRI
 */
export function toIri(url, identifer) {
  if (url && identifer) return identifer.includes("/") ? identifer : `${url}/${identifer}`
}

export function getAuthorizationConfig(config = {}) {
  let authConfig = {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`
    },
    ...config
  }

  if (localStorageService.getUserAccountIri())
    authConfig["headers"]["X-Account-Id"] = `${localStorageService.getUserAccountIri()}`

  return authConfig
}

export function getPatchContentTypeConfig(authenticatedCall = true) {
  if (authenticatedCall) {
    const config = getAuthorizationConfig()
    config.headers["Content-Type"] = "application/merge-patch+json"
    return config
  } else {
    return {
      headers: {
        "Content-Type": "application/merge-patch+json"
      }
    }
  }
}

export function getMultipartFormdataConfig(authenticatedCall = true) {
  if (authenticatedCall) {
    const config = getAuthorizationConfig()
    config.headers["Content-Type"] = "multipart/form-data"
    return config
  } else {
    return {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  }
}
